import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {SearchResponse} from "../objects/responses/searchResponse";
import {BaseResponse} from "../objects/common/baseResponse";
import {Product} from "../objects/products/product";
import {Http, RequestOptions, URLSearchParams} from "@angular/http";
import {TariffSource} from "../objects/tariffs/tariffSource";
import {ProductSearchRequest} from "../objects/requests/productSearchRequest";
import { ClassificationRequest } from "../objects/zonos/classificationRequest";
/**
 * Created by alex.y on 8/9/2017.
 */
@Injectable()
export class ProductService extends BaseApi {

    public search(request: ProductSearchRequest): Promise<BaseResponse<SearchResponse<Product>>> {
        let params = new URLSearchParams();

        params.append('query', request.Query);

        if(request.CustomerId)
            params.append('customerId', request.CustomerId.toString());

        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('source', request.Source != null ? request.Source.toString() : null);
        params.append('requestType', request.RequestType.toString());
        params.append('searchType', request.SearchType.toString());

        return this.get(new RequestOptions({
            url: `product/search`,
            search: params
        }));
    }

    public update(product: Product) : Promise<BaseResponse<Product>>{
        return this.put(new RequestOptions({
            url: `product`,
            body: product
        }));
    }

    public classification(request: ClassificationRequest) : Promise<BaseResponse<any>>{
        return this.post(new RequestOptions({
            url: `product/classification`,
            body: request
        }));
    }
}



// WEBPACK FOOTER //
// ./app/services/productService.ts